import {BasicService} from './basic.service';

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { API_DETENTIONV2_URL } from '../../connection.data';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { QueryResultsModel } from '../../_base/crud';

@Injectable()
export class DetentionV2Service extends BasicService {

    constructor(http: HttpClient){
        super(http);
        this.baseUrl = API_DETENTIONV2_URL;
    }

    getByPeriod(st, et): Observable<any[]>{
        const stStr = st.toLocaleString('sv');
        const etStr = et.toLocaleString('sv');

        return this.getPage({
            filter: {
                st: stStr,
                et: etStr
            },
            pageNumber: 0,
            pageSize: 0,
            sortField: 'id',
            sortOrder: 'desc',
            option: ''
        }).pipe(
            map((response: QueryResultsModel)=>{
                return response.items
            })
        )
    }

    saveExpandedDetention(payload: any): Observable<any> {
        return this.http.post<any>(`${this.baseUrl}/expanded`, payload);
    }

    /** Conserva la respuesta completa para conocer si las estadísticas se actualizaron. */
    updateDetention(payload: any): Observable<any> {
        return this.http.put<any>(`${this.baseUrl}/${payload.id}`, payload);
    }

    getExpandedDetentions(detentionRealtimeId: number): Observable<any> {
        return this.http.get<any>(`${this.baseUrl}/${detentionRealtimeId}/expanded`);
    }
}
